export class ImageUrlConstant {

  static CDN_BASE_URL = "https://cdn.aktifmusteri.com/";
  static NO_IMAGES = "no-images.webp";
  static PRODUCT_BASE_URL = ImageUrlConstant.CDN_BASE_URL + "download/program_image/product/";
  static PRODUCT_NOTE_BASE_URL = ImageUrlConstant.CDN_BASE_URL + "download/program_image/product_note/";
  static NO_IMAGES_URL = ImageUrlConstant.PRODUCT_BASE_URL + ImageUrlConstant.NO_IMAGES;



}
